
import React, { useEffect, useRef, useState } from "react";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";

import { useReactToPrint } from "react-to-print";
import axios from "axios";
import { Button } from "@material-ui/core";
import printJS from "print-js";
import { uri } from "../../../../help/Api";


let PizZipUtils = null;
if (typeof window !== "undefined") {
  import("pizzip/utils/index.js").then(function (r) {
    PizZipUtils = r;
  });
}

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}
async function loadFileFunc(url) {
  try {
    const response = await axios.get(url, { responseType: "arraybuffer" });
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch file from ${url}:`, error);
    throw error;
  }
}
async function loadInvData(url) {
  try {
    const response = await axios.get(url);
    console.log("the data is", response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch file from ${url}:`, error);
    throw error;
  }
}

export function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(blob);
  });
}

function base64ToFile(base64String, fileName){
    const base64 = base64String.split(',').pop();
    const paddedBase64 = base64.padEnd(base64.length+(base64.length%4), '=');
    try{

        const byteString = atob(paddedBase64);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for(let i=0; i< byteString.length; i++){
            ia[i]= byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], {type:"image/jpeg"});
        const file = new File([blob], fileName, {type:"image/jpeg"});
        return file;
    } catch(error){
        console.log("Failed to decode base64 sstring:", error);
        return null;
    }
   
}
export const generateDocument = async (
  setBase64String,
  fileName,
  invoiceData
) => {
  const content = await loadFileFunc(
    `${uri}PrintTemplates/download-template/${fileName}`
  );
  const data = await loadInvData(`${uri}_HInv?proc_id=${invoiceData?.proc_id}&&branchId=${invoiceData.branchId}&&procTypeInvProc=${invoiceData?.procTypeInvProc}`);
  const InvData = {
    ...data?.inv_data,
    ...data?.headerFooterData,
    inv_title: invoiceData.title+ " "+data?.inv_data?.inv_type_name + " " + data?.inv_data?.pay_type_name,
  };
  const itemsData = data?.invoceItems;

  const base64Regex = /^(?:data:)?image\/(png|jpg|jpeg|svg|svg\+xml);base64,/;

  const validBase64 =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

  function base64Parser(tagValue) {
    if (typeof tagValue !== "string" || !base64Regex.test(tagValue)) {
      return false;
    }

    const stringBase64 = tagValue.replace(base64Regex, "");

    if (!validBase64.test(stringBase64)) {
      throw new Error(
        "Error parsing base64 data, your data contains invalid characters"
      );
    }

    // For nodejs, return a Buffer
    if (typeof Buffer !== "undefined" && Buffer.from) {
      return Buffer.from(stringBase64, "base64");
    }

    // For browsers, return a string (of binary content) :
    const binaryString = window.atob(stringBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  }
  const zip = new PizZip(content);
  const doc = new Docxtemplater(zip, {
    linebreaks: true,
    paragraphLoop: true,
    // modules: [new ImageModule(imageOptions)],
  });
  // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
  doc.render({
    ...InvData,
    // first_name: "مؤسسة الذوق الراقي للمعدات الكهربائية ",
    inv_title: "فاتورة مبيعات نقدية كاش",

    products: [...itemsData],
  });

  const out = doc.getZip().generate({
    type: "blob",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });

  const formData = new FormData();
  formData.append("file", out, "invoice.docx");
  const imgFile = base64ToFile(data?.qr_image, "qr_code.jpeg")
  formData.append("image", imgFile);
  try {
    const response = await fetch(
      `${uri}PrintTemplates/mailmerge/upload`,
      // "http://localhost:3000/upload",
      {
        method: "POST",
        body: formData,
        // headers:{
        //     'Content-Type': 'multipart/form-data'
        // }
      }
    );
    if (response.ok) {
      console.log("File uploaded successfully", response);
      const blob = await response.blob();
      const base64String = await convertBlobToBase64(blob);
      setBase64String(base64String);
      const url = window.URL.createObjectURL(blob);
    } else {
      alert("Error uploading file");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

export default function TemplateTest({ fileName, invoiceData }) {
  const [base64String, setBase64String] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (base64String) PrintPdf();
  }, [base64String]);
  const PrintPdf = () => printJS({ printable: base64String, type: "pdf", base64: true });
  return (
    <>
      <Button
        disabled={isLoading}
        variant="text"
        onClick={async () =>{
            setIsLoading(true);
            await generateDocument(setBase64String, fileName, invoiceData);
            setIsLoading(false);
        }
        }
      >
        معاينة
      </Button>
    </>
  );
}

